<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push({name: 'product-new'}).catch((err) => {})">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <vue-good-table
      style="width: 100%;"
      styleClass="vgt-table condensed"
      :rows="getProducts"
      :columns="columns"
      :search-options="{
        enabled: true,
        trigger: '',
        placeholder: 'Procurar',
        skipDiacritics: true,
      }"
      :pagination-options="paginationOptions">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>

      <template slot="column-filter" slot-scope="{ column, updateFilters }">
        <v-select
          appendToBody
          v-if="column.filterOptions && column.filterOptions.enabled"
          :options="column.filterOptions.items"
          :placeholder="column.filterOptions.placeholder || 'Selecione'"
          @input="(valuesArray) => updateFilters(column, valuesArray)">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </template>

      <template slot="table-row" slot-scope="order">
        <span class="font-medium" v-if="order.column.field == 'imagem'">
          <div v-if="order.row.imageUrl">
            <img
              key="onlineImg"
              :src="order.row.imageUrl"
              alt="product-img"
              width="70"
              style="height: 70px"
              class="rounded-full shadow-md inline-block" />
          </div>
          <div v-else>
            <input
              type="file"
              class="hidden"
              :ref="'uploadInput-' + order.row.codigo"
              @change="uploadImage($event, order.row)"
              accept="image/*"
              name="file" />
            <feather-icon
              icon="UploadIcon"
              @click="$refs['uploadInput-' + order.row.codigo].click()"
              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
          </div>
        </span>
        <span class="font-medium" v-else-if="order.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="editProduct(order.row.codigo)" />
            <feather-icon v-if="order.row.trayUrl"
              icon="LinkIcon"
              svgClasses="h-5 w-5 text-success mr-4 cursor-pointer"
              @click="editProductLink(order.row)" />
            <feather-icon v-else
              icon="LinkIcon"
              svgClasses="h-5 w-5 text-danger mr-4 cursor-pointer"
              @click="editProductLink(order.row)" />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
              @click="deleteProduct(order.row.codigo)" />
          </div>
        </span>
        <span class="font-medium" v-else>
          {{ order.formattedRow[order.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import helpers from "@/helpers";

export default {
  data() {
    return {
      activePrompt: [],
      products: [],
      image: null,
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    }
  },
  computed: {
    getProducts() {
      return this.$store.state.products
    },
  },
  methods: {
    productsLength(products) {
      products = JSON.parse(products)
      return products.length
    },
    async uploadImage(event, product) {
      const image = event.target.files
      if (!image.length) return

      const formData = new FormData()
      formData.append("codigo", product.codigo)
      formData.append("image", image[0])
      const payload = {
        formData: formData,
        product: product,
        notify: this.$vs.notify
      }
      this.$store.dispatch("updateProduct", payload);
    },
    parseProducts(products) {
      return JSON.parse(products)
    },
    getAllLabelFilters() {
      const filters = {}
      filters.marca = this.$store.state.products.map(item => item.marca.trim())
      filters.modelo = this.$store.state.products.map(item => item.modelo.trim())

      for (let filter of Object.keys(filters)) {
        let index = this.columns.findIndex(item => {
          return item.field === filter
        })
        this.setDropdownFilter(index, filters[filter])
      }
    },
    setDropdownFilter(index, label) {
      label.sort((a, b) => a.localeCompare(b))
      label = [...new Set(label)]
      this.$set(this.columns[index], 'filterOptions', {
        enabled: true,
        items: label,
      })
    },
    mountTable() {
      this.columns = [{
          label: 'Imagem',
          field: 'imagem',
          tdClass: 'text-center'
        },
        {
          label: 'Código',
          field: 'codigo',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Descrição',
          field: 'descricaoPTBR',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Marca',
          field: 'marca',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Modelo',
          field: 'modelo',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Ações',
          field: 'ações',
          tdClass: 'vertical-middle',
          sortable: false
        }
      ]
    },
    editProductLink(product) {
      const trayUrl = window.prompt('Insira o link do produto na tray')
      if (!trayUrl) return

      const formData = {
        codigo: product.codigo,
        trayUrl
      }
      const payload = {
        formData: formData,
        product: product,
        notify: this.$vs.notify
      }
      this.$store.dispatch("updateProduct", payload);
    },
    editProduct(id) {
      console.log('edit: ', id)
    },
    deleteProduct(id) {
      console.log('deletar: ', id)
    },
  },
  async created() {
    this.helpers = helpers
    let payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchProductsItems", payload)
    this.mountTable()
    this.getAllLabelFilters()
  },
}

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
